(function(){
  'use strict';
  const root=document.querySelector('[data-crtx-page]');
  if(!root||root.dataset.initialized)return;
  root.dataset.initialized='true';
  const $=selector=>root.querySelector(selector);
  const $$=selector=>[...root.querySelectorAll(selector)];
  const form=$('[data-offer-form]');
  const settings=window.CRTX_SETTINGS||{};
  const giftPanel=$('[data-gift-panel]');
  const giftInput=$('[data-gift-opt-in]');
  let giftAvailability=typeof settings.gift?.available==='boolean'?settings.gift.available:null;
  let giftOptedOut=false;
  const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:settings.currency||'USD'}).format(cents/100);
  let active=window.CRTXOffer.getOffer(2,'subscription');
  let lastFocus=null;
  let verifiedProduct=null;
  const set=(selector,text)=>{const element=$(selector);if(element.textContent!==text)element.textContent=text;};
  const giftEligible=()=>active.mode==='subscription'&&[2,3].includes(active.quantity);
  function updateGift(){
    if(!giftPanel||!giftInput)return;
    giftPanel.hidden=!settings.gift?.enabled||giftAvailability===false;
    if(giftPanel.hidden)return;
    const eligible=giftEligible();
    const ready=giftAvailability===true;
    giftPanel.dataset.eligible=String(eligible&&ready);
    giftInput.checked=!giftOptedOut;
    giftInput.disabled=!eligible||!ready;
    $('[data-gift-check-row]').hidden=!eligible||!ready;
    $('[data-gift-badge]').hidden=!ready;
    const upgrade=$('[data-gift-upgrade]');
    upgrade.hidden=eligible||!ready;
    set('[data-gift-eyebrow]',eligible?'YOUR WELCOME GIFT':'SUBSCRIPTION WELCOME GIFT');
    set('[data-gift-title]','CRTX Focus Energy');
    if(!ready){set('[data-gift-description]','Checking gift availability…');return;}
    if(eligible){
      set('[data-gift-description]','One free bottle with your first delivery. Not included in renewals.');
    }else{
      set('[data-gift-description]','One free bottle with your first 2- or 3-tub subscription delivery. Not included in renewals.');
      upgrade.textContent=active.quantity===1?(active.mode==='subscription'?'Choose 2 tubs ↗':'Choose a 2-tub subscription ↗'):'Switch to subscription ↗';
    }
  }
  function update(){
    const data=new FormData(form);
    active=window.CRTXOffer.getOffer(Number(data.get('pack')),data.get('purchase'));
    const subscription=active.mode==='subscription';
    for(const count of [1,2,3]){
      const offer=window.CRTXOffer.getOffer(count,active.mode);
      set('[data-pack-unit="'+count+'"]',money(offer.perTub)+' / Tub');
    }
    set('[data-sub-price]',money(active.subscription));
    set('[data-once-price]',money(active.once));
    set('[data-saving]','Save '+active.saving+'% vs. '+(active.quantity===1?'a single tub':active.quantity+' single tubs'));
    $('[data-saving]').parentElement.hidden=active.saving===0;
    set('[data-daily]',money(active.perDay)+' / day');
    set('[data-supply]',active.days+'-Day Supply');
    set('[data-delivery]',subscription?'Delivered every '+active.interval:'One shipment · '+active.quantity+' '+(active.quantity===1?'tub':'tubs'));
    set('[data-retail]',money(active.retail));
    $('[data-retail]').hidden=active.retail===active.cents;
    set('[data-total]',money(active.cents));
    set('[data-renewal]',subscription?money(active.cents)+' today, then '+money(active.cents)+' every '+active.interval+' until canceled.':'One payment of '+money(active.cents)+'. No recurring deliveries.');
    set('[data-cta]',subscription?'Subscribe For '+money(active.cents):'Buy Now For '+money(active.cents));
    set('[data-sticky-price]',active.days+' days · '+money(active.perDay)+'/day');
    set('[data-form-status]','');
    $('.bundle-visual').dataset.quantity=String(active.quantity);
    const countWords={1:'One Tub.',2:'Two Tubs.',3:'Three Tubs.'};
    const dayWords={30:'Thirty',60:'Sixty',90:'Ninety'};
    set('[data-bundle-eyebrow]','YOUR '+active.days+'-DAY SUPPLY');
    set('[data-bundle-count]',countWords[active.quantity]);
    set('[data-bundle-days]',dayWords[active.days]+' Days Covered.');
    set('[data-bundle-copy]',active.saving>0?'Keep your focus formula on hand. Save '+active.saving+'% with the '+active.days+'-day '+(subscription?'subscription.':'supply.'):'One tub. Thirty days of supply. A single delivery.');
    set('[data-bundle-daily]',money(active.perDay));
    set('[data-bundle-supply]',active.days+' Days');
    set('[data-bundle-saving]',active.saving+'%');
    set('[data-bundle-fine]',active.days+'-day '+(subscription?'subscription':'supply')+' compared with '+(active.quantity===1?'one single tub':active.quantity+' single tubs')+' at $59.99 each. Supply calculated at 3 capsules per day.');
    set('[data-hero-supply]',active.days+'-Day '+(subscription?'Subscription':'Supply'));
    set('[data-hero-daily]',money(active.perDay)+' / Day');
    set('[data-top-offer]',active.days+' Days. '+money(active.perDay)+' A Day.');
    set('[data-closing-offer]',active.days+' Days Of Supply. '+money(active.perDay)+' A Day.');
    updateGift();
  }
  giftInput?.addEventListener('change',()=>{giftOptedOut=!giftInput.checked;updateGift();});
  root.addEventListener('crtx:gift-state',event=>{
    const state=event.detail||{};
    if(typeof state.availability==='boolean'||state.availability===null)giftAvailability=state.availability;
    if(typeof state.optedOut==='boolean')giftOptedOut=state.optedOut;
    updateGift();
  });
  $('[data-gift-upgrade]')?.addEventListener('click',()=>{
    if(active.quantity===1)form.querySelector('[name="pack"][value="2"]').checked=true;
    form.querySelector('[name="purchase"][value="subscription"]').checked=true;
    update();
    giftInput?.focus({preventScroll:true});
  });
  $('[data-value-offer]')?.addEventListener('click',()=>{
    form.querySelector('[name="pack"][value="2"]').checked=true;
    form.querySelector('[name="purchase"][value="subscription"]').checked=true;
    update();
  });
  form.addEventListener('change',update);
  // Browsers can restore form selections when returning from checkout.
  window.addEventListener('pageshow',update);
  update();
  function openDialog(dialog){if(dialog.open)return;lastFocus=document.activeElement;dialog.showModal();document.body.style.overflow='hidden';}
  window.CRTXDialogs={open:openDialog,close:closeDialog};
  function closeDialog(dialog){dialog.close();}
  $$('dialog').forEach(dialog=>{
    dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDialog(dialog);}});
    dialog.addEventListener('close',()=>{if(!document.querySelector('dialog[open]'))document.body.style.overflow='';if(lastFocus&&lastFocus.isConnected)lastFocus.focus();});
  });
  $$('[data-close-dialog]').forEach(button=>button.addEventListener('click',()=>closeDialog(button.closest('dialog'))));
  $$('[data-open-label]').forEach(button=>button.addEventListener('click',()=>openDialog($('[data-label-dialog]'))));
  form.addEventListener('submit',event=>{
    event.preventDefault();
    const giftSelection=settings.gift?.enabled&&giftEligible()&&giftAvailability===true?{giftOptIn:!giftOptedOut}:{};
    window.CRTXCommerce?.addOffer({...active,...giftSelection});
  });
  if('IntersectionObserver' in window){
    let heroVisible=true,offerVisible=false,valueOfferVisible=false,footerVisible=false;
    const sticky=$('[data-sticky]');
    const refresh=()=>{sticky.hidden=heroVisible||offerVisible||valueOfferVisible||footerVisible;};
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.target===$('.hero'))heroVisible=entry.isIntersecting;if(entry.target===form)offerVisible=entry.isIntersecting;if(entry.target===$('[data-value-offer]'))valueOfferVisible=entry.isIntersecting;if(entry.target===$('.footer'))footerVisible=entry.isIntersecting;});refresh();},{threshold:0});
    [$('.hero'),form,$('[data-value-offer]'),$('.footer')].filter(Boolean).forEach(target=>observer.observe(target));
  }
})();
